/* External dependencies */
import { gql } from '@apollo/client';

/* Local dependencies */
import { anonymousClient } from '../../../../client/graphql';
import { ListDevicesResponse } from '../../types';

export const LIST_DEVICES = gql`
  query ListDevices {
    T26ListDevices {
      devices {
        id
        address
        comment
        deviceLocation {
          lat
          lon
        }
        isVerified
        paymentService
        registrationDate
        user {
          id
        }
      }
      total
    }
  }
`;

export const listDevicesRequest = (): Promise<ListDevicesResponse> => {
  console.log('Listing devices');
  return anonymousClient
    .query({
      query: LIST_DEVICES,
      variables: {},
      fetchPolicy: 'network-only',
    })
    .then((res) => {
      console.log('Devices listed: ', res.data.T26ListDevices);
      return res.data.T26ListDevices;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
